module.exports = __webpack_public_path__ + "static/img/c_banner.cbc6984.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c_banner.png
// module id = p+bQ
// module chunks = 1